module.exports = __webpack_public_path__ + "static/media/ico-new-termino.ee55c743.svg";